import React from 'react';

import { EntityListViewProps } from './index.types';
import { EntityListViewView } from './index.view';

export function EntityListView(props: EntityListViewProps) {
  return <EntityListViewView {...props} />;
}

export type { EntityListViewProps } from './index.types';
